module.exports = __webpack_public_path__ + "static/img/newsBg.43bbb4c.jpg";


//////////////////
// WEBPACK FOOTER
// ./image/homePage/newsBg.jpg
// module id = 108
// module chunks = 502